/**
 * Optimize Workflows Lesson
 * Skill Area: Operations
 * Balance team workload to prevent burnout
 */

import type { LessonDefinition } from '../types';
import { OPTIMIZE_WORKFLOWS_AI_PROMPT, OPTIMIZE_WORKFLOWS_CONTEXT_SCENARIOS } from '../prompts/optimize-workflows.prompt';

export const optimizeWorkflows: LessonDefinition = {
  id: 'optimize-workflows',
  title: 'Optimize Workflows',
  displayTitle: 'Balance Team Workload to Prevent Burnout',
  subTitle: 'Balance team workload sustainably',
  persona: 'Lyra',
  skillArea: 'Operations',
  topicId: 'programs-projects',
  topicTitle: 'Programs & Projects',
  topicDescription: 'Analyze options, build plans, monitor finances, and balance team workload.',
  format: 'scenario',
  difficulty: 'Intermediate',
  estimatedMinutes: 7,
  tags: ['workflows', 'optimization', 'team'],
  dailyEligible: true,
  releasedAt: '2025-01-23T00:00:00.000Z',
  route: '/micro/optimize-workflows',
  storyBeat: 'Protect your team from burnout with smart workload analysis.',
  contextScenarios: OPTIMIZE_WORKFLOWS_CONTEXT_SCENARIOS,
  introPrompt: "Your team is drowning in unnecessary work—approvals that don't add value, handoffs that create bottlenecks, meetings that could be emails. But 'fix the workflow' means having hard conversations. Let's practice.",
  steps: [
    "Identify the workflow conversation you've been avoiding",
    "Understand the stakeholders involved and their concerns",
    "Practice proposing workflow changes with realistic pushback",
    "Debrief and build your approach for the real conversation"
  ],
  promptGuidance: 'Describe the workflow conversation you need to have.',
  aiPrompt: OPTIMIZE_WORKFLOWS_AI_PROMPT,
  inputPlaceholder: "e.g., Budget request, deadline pushback...",
  quickPrompts: [
    'Request additional budget',
    'Push back on deadline',
    'Streamline handoffs',
    'Retire outdated process'
  ]
};
